import { scheduler } from './base';

import { MutationArg } from 'v2/types';
import { BalanceScheduleModel } from 'v2/types/ScheduleModel';

export const schedulerService = {
  getBalanceSchedules(): Promise<BalanceScheduleModel[]> {
    return scheduler.get('balance-job').json();
  },

  updateBalanceSchedules(
    _key: string,
    { arg }: MutationArg<Omit<BalanceScheduleModel, 'id'>[]>
  ): Promise<BalanceScheduleModel> {
    return scheduler.put('balance-job', { json: arg }).json();
  },

  deleteBalanceSchedule(_key: string, { arg: scheduleId }: MutationArg<string>): Promise<BalanceScheduleModel[]> {
    return scheduler.delete(`job/${scheduleId}`).json();
  },
};
